/**
 * Sync status enum for cloud synchronization
 */
export enum SyncStatus {
  Idle = 'idle',
  Syncing = 'syncing',
  Error = 'error',
  Offline = 'offline',
}
